export default __webpack_public_path__ + "a25004e635201dfafd4ad977efae827a.svg";